import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "drag",
  "use": "drag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"currentcolor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"drag\"><path d=\"M9.556 5.778a1.778 1.778 0 11-3.556 0 1.778 1.778 0 013.556 0zM9.556 12A1.778 1.778 0 116 12a1.778 1.778 0 013.556 0zM7.778 20a1.778 1.778 0 100-3.555 1.778 1.778 0 000 3.555zM17.556 5.778a1.778 1.778 0 11-3.556 0 1.778 1.778 0 013.556 0zM17.556 12A1.778 1.778 0 1114 12a1.778 1.778 0 013.556 0zM15.778 20a1.778 1.778 0 100-3.556 1.778 1.778 0 000 3.556z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol